import { CHANNEL } from "./channel";

/**
 * The public build drops every URL flag but these before any module reads the address (main.ts imports this first):
 * `?debug`, `?sandboxstore`, `?skin=`, `?allhq` and the rest are for the Mac and the beta, not for players — `?debug`
 * opens the debug menu and the sandbox store hands out free gems. Kept: the picture flags (`lite`, `webp`, `autoq`),
 * the perf overlay (`stats`) and campaign tags (`utm_*`, read by the analytics session event).
 */
export const PublicUrlFlag = /^(lite|webp|autoq|stats|utm_[a-z]+)$/;

/** `search` with only the public flags left ("" when none are). */
export function publicSearch(search: string): string {
  const q = new URLSearchParams(search);
  for (const key of [...q.keys()]) if (!PublicUrlFlag.test(key)) q.delete(key);
  const s = q.toString();
  return s ? `?${s}` : "";
}

if (CHANNEL === "public" && typeof location !== "undefined" && location.search) {
  const clean = publicSearch(location.search);
  if (clean !== location.search) history.replaceState(history.state, "", `${location.pathname}${clean}${location.hash}`);
}
